import { UserAddressDtosCacheKey, UserAddressDtosChannelKey } from '../constant';

const Storage = Mach.requireModule('Storage');

// 缓存收货地址
const saveAddressCache = (data, isLogin = true, userId = '') => {
  const { addressDtos = [], showPopUp2Style = false } = data || {};
  const cacheData = { addressDtos: isLogin ? addressDtos : [], userId: isLogin ? userId : '', showPopUp2Style };
  _storageAddressData(cacheData);
};

// 清除数据
const removeAddressCache = (addressId = '') => {
  const cacheData = getAddressCache() || {};
  const { showPopUp2Style = false, addressDtos = [] } = cacheData;

  if (addressId && addressDtos.length > 0) {
    // 移除addressId
    const updatedAddressDtos = addressDtos.filter((address) => address.addressId !== addressId);
    const updatedCacheData = {
      ...cacheData,
      addressDtos: updatedAddressDtos
    };
    _storageAddressData(updatedCacheData);
  } else {
    //  保留实验
    const cacheData = { showPopUp2Style };
    _storageAddressData(cacheData);
  }
};

// 获取
const getAddressCache = () => {
  if (Mach.env.isAndroid) { // 安卓保存字典有问题，需要保存为字符串，读取时再转为JSON
    const addressDtosStr = Storage.getString({
      channel: UserAddressDtosChannelKey,
      key: UserAddressDtosCacheKey
    });
    let addressDtos = [];
    let showPopUp2Style = false;
    let userId = '';
    try {
      const cacheData = JSON.parse(addressDtosStr);
      addressDtos = cacheData?.addressDtos;
      showPopUp2Style = cacheData?.showPopUp2Style;
      userId = cacheData?.userId;
    } catch (error) {
      addressDtos = [];
    }
    return { showPopUp2Style, addressDtos: addressDtos || [], userId };
  } else {
    const { addressDtos, userId, showPopUp2Style } = Storage.getDictionary({
      channel: UserAddressDtosChannelKey,
      key: UserAddressDtosCacheKey
    }) || {};
    return { showPopUp2Style, addressDtos: addressDtos || [], userId };
  }
};

const _storageAddressData = (cacheData) => {
  if (Mach.env.isAndroid) { // 安卓保存数组有问题，需要先转为字符串
    Storage.setString({
      channel: UserAddressDtosChannelKey,
      key: UserAddressDtosCacheKey,
      value: JSON.stringify(cacheData)
    });
  } else { // iOS 可以直接保存为字典
    Storage.setDictionary({
      channel: UserAddressDtosChannelKey,
      key: UserAddressDtosCacheKey,
      value: cacheData
    });
  }
};

export { saveAddressCache, getAddressCache, removeAddressCache };
